import DayjsUtils from '@date-io/dayjs';
import Button from '@material-ui/core/Button';
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import SearchIcon from '@material-ui/icons/Search';
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import dayjs from 'dayjs';
import React, { useState, useEffect } from "react";
import { useActions, useValues } from 'kea';
import ReplayIcon from '@material-ui/icons/Replay';

import assetlogic from 'src/store/asset';
import vehiclelogic from 'src/store/vehicle';
import prettytime from 'src/utils/prettytime';
import { replaylogic, preferenceslogic } from 'src/store/global';
import { IconButton, Tooltip } from '@material-ui/core';
import { minHistoryDate } from 'src/utils/constants';

const useStyles = makeStyles({
	root: {
		minWidth: "100%"
	},
	table: {
		minWidth: "500px",
		maxHeight: 400
	},
	limitFont: {
		fontSize: 13
	}
});


export default function History({ asset }) {
	const classes = useStyles();

	const { history } = useValues(assetlogic);
	const { fetchHistory } = useActions(assetlogic);

	const { replay } = useValues(vehiclelogic);
	const { fetchReplay, setReplay } = useActions(vehiclelogic);

	const { setVehicle: replaySetVehicle, setMax } = useActions(replaylogic);

	const { replay: replayPref } = useValues(preferenceslogic);
	const { setReplay: setReplayPref } = useActions(preferenceslogic);

	const [selectedDate, handleDateChange] = useState(new Date());

	useEffect(() => {
		if (replay?.status?.length > 0) {
			replaySetVehicle(replay);
			setReplayPref({ ...replayPref, show: true });
			setMax(replay.status.length);
		}
	}, [replay])

	const handleSearch = () => {
		fetchHistory({
			_id: asset._id,
			start: dayjs(selectedDate).startOf('day'),
			stop: dayjs(selectedDate).endOf('day')
		})
	}

	const handleReplay = (query) => {
		fetchReplay(query)
		// console.log(query);
	}

	return (
		<div className={classes.root} >
			<TableContainer style={{ maxHeight: '400px' }}>
				<Table stickyHeader size="small" aria-label="a dense table" className={classes.table}>
					<TableHead>
						<TableRow key={"type-rego"}>
							<TableCell align="right" style={{ minWidth: 100 }}>
								<b>{`Pick a Date: `}</b>
							</TableCell>
							<TableCell align="center" style={{ paddingRight: 0, fontSize: 22 }}>
								<MuiPickersUtilsProvider utils={DayjsUtils}>
									<DatePicker
										autoOk
										ampm={false}
										variant="inline"
										format="DD/MM/YYYY"
										value={selectedDate}
										minDate={minHistoryDate}
										onChange={handleDateChange}
										disableFuture
									/>
								</MuiPickersUtilsProvider>
							</TableCell>
							<TableCell colSpan={2} align="center" style={{ paddingLeft: 0 }}>
								<Button
									variant="contained"
									color="primary"
									size="small"
									className={classes.button}
									startIcon={<SearchIcon />}
									onClick={handleSearch}
								>
									Search
								</Button>
								{/* <IconButton type="submit" className={classes.iconButton} aria-label="search">
								<SearchIcon />
							</IconButton> */}
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody >
						{
							// rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => (
							history?.status?.map((row, index) => (
								<TableRow key={`inginition-address-${index}`}>
									<TableCell className={classes.limitFont} align="left">
										{row.vehicle.name}
									</TableCell>
									<TableCell className={classes.limitFont} align="left">
										<div>
											<b>From:</b> {dayjs(row.start_time).format('HH:mm DD-MM')}<br />
											<b>To:</b>{dayjs(row.stop_time).format('HH:mm DD-MM')}{row.finished || ' (Ongoing)'}
										</div>
									</TableCell>
									{row.stop_time ? <TableCell className={classes.limitFont} align="left">
										<b>Dist: </b>{`${row.distance / 1000} KM(s)`} m <br />
										<b>Time: </b>{prettytime(row.duration)}
									</TableCell> : <TableCell className={classes.limitFont} align="left">
										Ongoing
									</TableCell>}
									<TableCell className={classes.limitFont} align="left">
										<Tooltip title='Replay this Trip'>
											<IconButton size={'small'} onClick={() => handleReplay({
												_id: row.vehicle._id,
												start: row.start_time,
												stop: row.stop_time || (new Date()).toISOString()
											})}>
												<ReplayIcon fontSize='small' />
											</IconButton>
										</Tooltip>
									</TableCell>
								</TableRow>
							))
						}
						{/* {emptyRows > 0 && (
					<TableRow style={{ height: 49 * emptyRows }}>
						<TableCell colSpan={6} />
					</TableRow>
				)} */}
					</TableBody>
				</Table>
			</TableContainer>

			{/* <TablePagination
			rowsPerPageOptions={[5,10,15]}
			component="div"
			count={rows.length}
			rowsPerPage={rowsPerPage}
			page={page}
			onChangePage={handleChangePage}
			onChangeRowsPerPage={handleChangeRowsPerPage}
		/> */}
		</div >
	);
}
